export class CommonHandler {
    static scrollTo(element, to, duration) {
        let start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20

        const animateScroll = function () {
            currentTime += increment
            element.scrollTop = Math.easeInOutQuad(currentTime, start, change, duration)
            if (currentTime < duration) {
                setTimeout(animateScroll, increment)
            }
        }
        animateScroll()
    }
}

export default CommonHandler
